import {
  apiClient,
} from "./apiClient";

import type {
  CreateInventoryTransferData,
  CreateInventoryTransferInput,
  InventoryTransferDetailsData,
  InventoryTransfersPageData,
  InventoryTransfersQuery,
} from "../types/inventory-transfers.types";


/* =========================================================
 * Helpers
 * ======================================================= */

function setStringParam(
  params:
    URLSearchParams,

  key: string,

  value:
    string | undefined,
) {
  if (!value?.trim()) {
    return;
  }

  params.set(
    key,
    value.trim(),
  );
}


function buildInventoryTransfersQuery(
  query:
    InventoryTransfersQuery = {},
): string {
  const params =
    new URLSearchParams();


  setStringParam(
    params,
    "productId",
    query.productId,
  );


  setStringParam(
    params,
    "sourceWarehouseId",
    query.sourceWarehouseId,
  );


  setStringParam(
    params,
    "targetWarehouseId",
    query.targetWarehouseId,
  );


  setStringParam(
    params,
    "performedBy",
    query.performedBy,
  );


  setStringParam(
    params,
    "dateFrom",
    query.dateFrom,
  );


  setStringParam(
    params,
    "dateTo",
    query.dateTo,
  );


  setStringParam(
    params,
    "cursor",
    query.cursor,
  );


  if (
    query.limit !==
    undefined
  ) {
    params.set(
      "limit",
      String(
        query.limit,
      ),
    );
  }


  const queryString =
    params.toString();


  return queryString
    ? `?${queryString}`
    : "";
}


/* =========================================================
 * Warehouse Transfer API
 * ======================================================= */

export const inventoryTransfersApi = {

  /**
   * GET /inventory/transfers
   *
   * Transfer history.
   */
  list(
    query:
      InventoryTransfersQuery = {},
  ) {
    return apiClient.get<
      InventoryTransfersPageData
    >(
      `/inventory/transfers${buildInventoryTransfersQuery(
        query,
      )}`,
    );
  },


  /**
   * GET /inventory/transfers/:transferId
   *
   * Transfer details.
   */
  getById(
    transferId: string,
  ) {
    return apiClient.get<
      InventoryTransferDetailsData
    >(
      `/inventory/transfers/${encodeURIComponent(
        transferId,
      )}`,
    );
  },


  /**
   * POST /inventory/transfers
   *
   * Move AVAILABLE stock between warehouses.
   */
  create(
    input:
      CreateInventoryTransferInput,
  ) {
    return apiClient.post<
      CreateInventoryTransferData
    >(
      "/inventory/transfers",
      input,
    );
  },
};
